import { render, staticRenderFns } from "./develop.vue?vue&type=template&id=21efd6d7&scoped=true&"
import script from "./develop.vue?vue&type=script&lang=js&"
export * from "./develop.vue?vue&type=script&lang=js&"
import style0 from "./develop.vue?vue&type=style&index=0&id=21efd6d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21efd6d7",
  null
  
)

export default component.exports